module.exports = __webpack_public_path__ + "img/male-student.e1da5274.png";